var map = {
	"./content/01-logo.webp": "e416",
	"./content/04-home-what-is-gb.webp": "c2da",
	"./content/06-install-step-1-download.webp": "1cc0",
	"./content/07-install-step-2-unknown-sources.webp": "9024",
	"./content/08-install-step-3-find-apk.webp": "68a9",
	"./content/09-install-step-4-install.webp": "d9e2",
	"./content/10-install-step-5-setup.webp": "a98f",
	"./content/11-install-step-6-optional.webp": "582e",
	"./content/14-pc-hero.webp": "b9b1",
	"./content/15-blog-login.webp": "8fe1",
	"./content/16-blog-send-message.webp": "d550",
	"./content/17-blog-install-error.webp": "ddf6",
	"./manifest": "6568",
	"./manifest.json": "6568",
	"./ui-mockups/02-ui-hero-mockup.webp": "d616",
	"./ui-mockups/03-ui-toc-mockup.webp": "59cd",
	"./ui-mockups/05-ui-app-notice-mockup.webp": "9aa6",
	"./ui-mockups/12-ui-install-guide-mockup.webp": "e5b6",
	"./ui-mockups/13-ui-download-page-mockup.webp": "1f05"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "635d";